import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/loader/loader.component';
import { AuthSessionService } from './auth/auth-session.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  constructor(private authSessionService: AuthSessionService) {
    // Check if this is a disbursement URL before any session logic runs
    const path = window.location.pathname;
    if (path.includes('/pda-disburesement/')) {
      this.authSessionService.enterDisbursementMode();
    }
  }

  async ngOnInit() {
    const path = window.location.pathname;
    const isPublicAuthPage = path.includes('/login') ||
      path.includes('/forgot-password') ||
      path.includes('/reset-password') ||
      path.includes('/otp');

    if (!isPublicAuthPage) {
      await this.authSessionService.initSessionCheck();
    }
  }
}
